import { TestService } from '@/services/test.services'
import { AuthServices } from '@/services/auth.services'
import { DashboardServices } from '@/services/dashboard.services'
import { StoreServices } from '@/services/store.services'
import { UserServices } from '@/services/user.services'
import { StoreMemberService } from '@/services/storeMember.services'
import { DropdownServices } from '@/services/dropdown.services'
import { PcbRegisterServices } from '@/services/pcb-register.services'
import { GoodsServices } from '@/services/goods.services'
import { GroupServices } from '@/services/group.services'
import { MessagePageServices } from '@/services/messagePage.services'
import { DashboardAccountInquiryServices } from '@/services/dashboardAccountInquiry.services'
import { EgmRcServices } from '@/services/egm-rc.services'
import { SystemAnnouncementService } from '@/services/systemAnnouncement.services'
import { EcPaymentServices } from '@/services/ecPayment.services'
import { TimeZoneService } from '@/services/timeZone.services'
import { SettlementTimezoneService } from '@/services/settlementTimezone.services'
import { StoreMetricThresholdService } from '@/services/storeMetricThreshold.services'

const api = {
  test: new TestService(), // 測試範例
  auth: new AuthServices(), // 系統登入
  dashboard: new DashboardServices(), // 控制台
  store: new StoreServices(), // 商家
  user: new UserServices(), // 使用者
  storeMember: new StoreMemberService(), // 成員
  dropdown: new DropdownServices(), // 下拉選單
  pcbRegister: new PcbRegisterServices(), // 機台
  goods: new GoodsServices(), // 商品
  group: new GroupServices(), // 群組
  message: new MessagePageServices(), // 營業訊息
  dashboardAccountInquiry: new DashboardAccountInquiryServices(), // 控制台:帳務查詢
  egmRC: new EgmRcServices(), // EgmRC 相關 API
  systemAnnouncement: new SystemAnnouncementService(), // 系統公告
  ecPayment: new EcPaymentServices(), // 綠界金流相關 API
  timeZone: new TimeZoneService(), // 時區相關 API
  settlementTimezone: new SettlementTimezoneService(), // 店家結帳時區相關 API
  storeMetricThreshold: new StoreMetricThresholdService() // 店家指標門檻設定相關 API
}

export { api }
